import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { ErrorService } from '../services/error.service';
import { SHARED_CONFIG } from '../util-config/token/shared-config.token';

const matchesStatusPattern = (pattern: string, status: number): boolean => {
  // Range inclusive: "400-500" → 400 <= status <= 500
  const rangeMatch = pattern.match(/^(\d+)-(\d+)$/);
  if (rangeMatch) {
    return status >= +rangeMatch[1] && status <= +rangeMatch[2];
  }
  // From: "400+" → status >= 400
  const fromMatch = pattern.match(/^(\d+)\+$/);
  if (fromMatch) {
    return status >= +fromMatch[1];
  }
  // Less than: "<500" → status < 500
  const lessThanMatch = pattern.match(/^<(\d+)$/);
  if (lessThanMatch) {
    return status < +lessThanMatch[1];
  }
  // Exact match: "400"
  return +pattern === status;
};

export const hasTechnicalError = (
  response: HttpResponse<unknown> | HttpErrorResponse,
  request: HttpRequest<unknown>,
) => {
  const headerValue = request.headers.get('X-allow-technical-error-modal');
  return (
    headerValue &&
    headerValue !== 'OFF' &&
    headerValue.split('|').some((pattern) => matchesStatusPattern(pattern.trim(), response.status))
  );
};

export const TechnicalErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const errorService = inject(ErrorService);
  const config = inject(SHARED_CONFIG);

  if (request.url.includes(config.apiUrl)) {
    const clonnedRequest = request.clone();
    return next(clonnedRequest).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((response: any) => {
        if (hasTechnicalError(response, request)) {
          errorService.hasTechnicalError.set(true);
        }
        return response;
      }),
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          hasTechnicalError(error, request)
        ) {
          errorService.hasTechnicalError.set(true);
        }

        return throwError(() => error);
      }),
    );
  }
  return next(request);
};
